import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

//impoertacion componentes
import img from "../Loader/spinner.gif";
import { obtenerInstituciones } from "../../Services/Rest";
import md5 from "md5";

function CreaAutoevaluacionSecH(props) {
  const [isLoading, setLoading] = useState(false);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [postNumeroOm, setPostNumeroOm] = useState([]);
  const [postTexto, setPostTexto] = useState([]);
  const [postAccion, setPostAccion] = useState([]);
  const [postElementoVerificacion, setPostElementosVerificacion] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaOmEstandaresApoyo",
      data: {
        numeroOm: postNumeroOm,
        texto: postTexto,
        accion: postAccion,
        elementoVerificacion: postElementoVerificacion,
        titulo: props.idTitulo,
        solicitudId: props.idSolicitud,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        window.location.reload("/");
        window.alert("creada");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear" + error);
      });
  };
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nueva Om{props.idTitulo}
      </button>
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Crear Oportunidad de mejora
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive">
                    <form className="user">
                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Om"
                            onChange={(e) => setPostNumeroOm(e.target.value)}
                          />
                        </div>
                        <div className="col-sm-6">
                          <input
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Texto"
                            onChange={(e) => setPostTexto(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="form-group row">
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Acciones de mejora"
                            onChange={(e) => setPostAccion(e.target.value)}
                          />
                        </div>
                        <div className="col-sm-6 mb-3 mb-sm-0">
                          <textarea
                            type="text"
                            className="form-control form-control-user"
                            placeholder="Elementos de verificación"
                            onChange={(e) =>
                              setPostElementosVerificacion(e.target.value)
                            }
                          />
                        </div>
                      </div>
                      {isLoading ? (
                        ""
                      ) : (
                        <a>
                          <button
                            className="btn btn-primary btn-user btn-block "
                            onClick={postData}
                          >
                            Guardar
                          </button>
                        </a>
                      )}
                      {isLoading ? (
                        <div>
                          <img
                            style={{ width: "200px", height: "200px" }}
                            src={img}
                          />{" "}
                        </div>
                      ) : (
                        ""
                      )}
                      <hr />
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default CreaAutoevaluacionSecH;
